export let SlotsType = /*#__PURE__*/function (SlotsType) {
  SlotsType["FREE"] = "FREE";
  SlotsType["BUSY"] = "BUSY";
  return SlotsType;
}({});
//# sourceMappingURL=ServiceSlots.js.map